// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_assessments,
  add_assessments,
  update_assessments,
  delete_assessments,
  get_assessments_questions
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const initialState = {
  assessments: [],
  assessmentsquestionlist: [],
  assessmentsfilterlist: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  ptotalPages: 0,
  ppageSize: 10,
  pcount: 0,
  pactivePage: 1,
  ploading: false,
  perror:null,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    assessments_name :"",
    category :"",
    price :"",
    mrp :"",
    main_image :"",
    description :"",
    brand :"",
  },
};
// Async Thunks for API Calls
export const fetchassessmentsquestion = createAsyncThunk(
  "assessments/fetchassessmentsquestion",
  async ({page,page_size,ass_id,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_assessments_questions(page,page_size,ass_id,school_id, token, signal);
         console.log("response",response);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);




// Async Thunks for API Calls
export const fetchassessments = createAsyncThunk(
  "assessments/fetchassessments",
  async ({ page, page_size,school_id,token, signal }, { rejectWithValue }) => {
    try {
        console.log("token",token)
      const response = await get_assessments(page, page_size,school_id, token, signal);

        console.log(response);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createassessments = createAsyncThunk(
  "assessments/createassessments",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_assessments(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateassessments = createAsyncThunk(
  "assessments/updateassessments",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_assessments(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteassessments = createAsyncThunk(
  "assessments/deleteassessments",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_assessments({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const assessmentsSlice = createSlice({
  name: "assessments",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    setpActivePage(state, action) {
      state.pactivePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
        reduxState.formData = { ...action.payload };
      },
    resetFormData(state) {
      state.formData = {
        assessments_name :"",
        category :"",
        price :"",
        mrp :"",
        main_image :"",
        description :"",
        brand :"",
       
      };
    },
    setassessments(state, action) {
      state.assessments = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setpPageSize(state, action) {
      state.ppageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // User list
      .addCase(fetchassessmentsquestion.pending, (state) => {
        state.ploading = true;
      })
      .addCase(fetchassessmentsquestion.fulfilled, (state, action) => {
        state.ploading = false;
        console.log("=====",action.payload.results)
        state.assessmentsquestionlist = action.payload.results;
        // console.log(state.assessmentslist)
        state.pcount = action.payload.count;
        state.ptotalPages = Math.ceil(action.payload.count / state.ppageSize);
      })
      .addCase(fetchassessmentsquestion.rejected, (state, action) => {
        state.ploading = false;
        state.perror = action.payload;

      })
      // Fetch Classes
      .addCase(fetchassessments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchassessments.fulfilled, (state, action) => {
        console.log("Fetch Assessments Fulfilled:", action.payload);
        state.loading = false;
        state.assessments = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      
      .addCase(fetchassessments.rejected, (state, action) => {
        console.error("Fetch Assessments Failed:", action.payload);
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(createassessments.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createassessments.fulfilled, (state, action) => {
        state.addLoading = false;
        state.assessmentss = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createassessments.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateassessments.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateassessments.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateassessments.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteassessments.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteassessments.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteassessments.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");

        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setassessments,
  setActivePage,
  setpActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize,
  setpPageSize,
  setSchoolId,
} = assessmentsSlice.actions;
export default assessmentsSlice.reducer;
